export default __webpack_public_path__ + "static/media/prasha_logo.924a50f6.jpg";